import React, { useEffect, useState } from 'react';

import { SelectContentsModal } from 'components/content';
import useModal from 'hooks/useModal';
import { EventQuery } from 'queries';
import { toast } from 'react-toastify';
import { IContent, IEvent } from 'types';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import { EventApi } from 'api';

interface Props {
  event: IEvent;
}

function ManageContents({ event }: Props) {
  const { handleClose } = useModal();
  const { mutate } = EventQuery.useUpdateContents();
  const [contents, setContents] = useState<IContent[] | null>(null);

  const handleSubmit = (contents: IContent[]) => {
    if (!event) return;
    mutate(
      {
        id: event.id,
        contentIds: contents.map((v) => v.id),
        contentSortOrder: contents.map((v, index) => ({
          contentId: v.id,
          sortOrder: index,
        })),
      },
      {
        onSuccess: () => {
          toast.success('콘텐츠가 저장되었습니다.');
          handleClose();
        },
        onError: () => {
          toast.error(DEFAULT_ERROR_MESSAGE);
        },
      },
    );
  };

  const init = async () => {
    const res = await EventApi.getContents(event.id);
    const sortedContents = res.data.sort((a: IContent, b: IContent) => {
      const aIndex = event.contentSortOrder?.find(
        (v) => v.contentId === a.id,
      )?.sortOrder;
      const bIndex = event.contentSortOrder?.find(
        (v) => v.contentId === b.id,
      )?.sortOrder;
      return (aIndex || 0) - (bIndex || 0);
    });
    setContents(sortedContents);
  };

  useEffect(() => {
    init();
  }, []);

  if (!contents) return null;
  return (
    <SelectContentsModal
      contents={contents}
      onSubmit={handleSubmit}
      pageType="EVENT_MODAL"
    />
  );
}

export default ManageContents;
